export default __webpack_public_path__ + "static/media/AnanthKashyap.dba099bd.png";